export const environment = {
  production: true,
  CI_COMMIT_SHA: process.env.CI_COMMIT_SHA,
  FULTONGRACE_URL: 'https://www.fultongrace.com',
  STRIPE_PUBLISHABLE_KEY: 'pk_live_ByD4EPHMji7diDPDOfYdq8kt',
  DOMAIN: 'fultongrace.com',
  ENV_NAME: 'prod',
  PAYLOAD_ORG_ID: 'acct_3eCvJTvHFt4jNxrpnYa0V',
};
